module.exports = __webpack_public_path__ + "static/media/flatbed-correct.aa294d22.jpg";